import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const ChapterButtons = ({
  reletedProductresult,
  reletedProduct2,
  post,
  videoCompleted,
}) => {
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const navigate = useNavigate();

  // ✅ Pass / Fail Logic
  const passPercentage = 30;

  const percentage =
    reletedProductresult?.totalMarks > 0
      ? (
          (reletedProductresult?.obtainedMarks /
            reletedProductresult?.totalMarks) *
          100
        ).toFixed(2)
      : 0;

  const examStatus =
    percentage >= passPercentage ? "PASS ✅" : "FAIL ❌";

  const handleNext = () => {
    // Exam hai aur result abhi nahi aaya
    if (
      reletedProduct2 &&
      Object.keys(reletedProduct2).length > 0 &&
      !reletedProductresult
    ) {
      navigate("/MCQ/" + reletedProduct2?.slug);
    } else {
      let current =
        Number(localStorage.getItem("course_progress")) || 0;

      localStorage.setItem(
        "course_progress",
        current + 1
      );

      navigate("/cources/english-spoken-course");
    }
  };

  return (
    <div className="d-flex flex-column text-white buttons-container">
      <div
        className="text-center mt-2 mb-1 rounded px-2 py-1 about-btn"
        onClick={() => setIsAboutOpen(!isAboutOpen)}
      >
        About This Video
      </div>

      {isAboutOpen && (
        <div
          className="mb-2 rounded px-2 py-1 about-details"
          dangerouslySetInnerHTML={{ __html: post?.description }}
        />
      )}

      {/* Video complete hone ke baad Next button */}
      {videoCompleted && (
        <div
          className="text-center my-2 rounded px-2 py-2 take-exam-btn"
          style={{ cursor: "pointer" }}
          onClick={handleNext}
        >
          {reletedProduct2 && !reletedProductresult
            ? "➡ Next (Take Exam)"
            : "➡ Next"}
        </div>
      )}

      {/* Result Card */}
      {reletedProductresult && reletedProduct2 && (
        <div className="text-center mt-2 mb-1 rounded px-2 py-1 about-btn mb-5">
          <div className="exam-result-card mt-3 p-3 rounded shadow-sm">
            <div className="text-center fw-bold mb-3 exam-result-title">
              📊 Exam Result
            </div>

            <div className="result-row d-flex justify-content-between">
              <span>Total Marks</span>
              <span>{reletedProductresult?.totalMarks}</span>
            </div>

            <div className="result-row d-flex justify-content-between">
              <span>Obtained Marks</span>
              <span>{reletedProductresult?.obtainedMarks}</span>
            </div>

            <div className="result-row d-flex justify-content-between">
              <span>Total Questions</span>
              <span>{reletedProductresult?.totalquestion}</span>
            </div>

            <div className="result-row d-flex justify-content-between text-success">
              <span>Right Answers</span>
              <span>{reletedProductresult?.rightAnswer}</span>
            </div>

            <div className="result-row d-flex justify-content-between text-danger">
              <span>Wrong Answers</span>
              <span>{reletedProductresult?.wrongAnswer}</span>
            </div>

            {/* ✅ Percentage */}
            <div className="result-row d-flex justify-content-between">
              <span>Percentage</span>
              <span>{percentage}%</span>
            </div>

            {/* ✅ Pass / Fail */}
            <div
              className={`result-row d-flex justify-content-between fw-bold ${
                percentage >= passPercentage
                  ? "text-success"
                  : "text-danger"
              }`}
            >
              <span>Status</span>
              <span>{examStatus}</span>
            </div>

            <div
              className="text-center mt-3 rounded px-2 py-2 take-exam-btn"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let current =
                  Number(localStorage.getItem("course_progress")) || 0;

                localStorage.setItem(
                  "course_progress",
                  current + 1
                );

                navigate("/cources/english-spoken-course");
              }}
            >
              📚 Back To Chapter List
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChapterButtons;